import React from "react"
import PropTypes from "prop-types"
import { formatRawCredentialString } from "../Helper"
import { formatAccessCredential } from "../Helper"
class Authorization extends React.Component {
  constructor(props) {
    super(props);
    this._last_websocket_message = null;
    this.state = {
      authorization: null,
      authorizations: [],
      readers: null,
      isLoading: false,
      errorMessage: null,
      web_aws_access_key_id: props.web_aws_access_key_id,
      web_aws_secret_access_key: props.web_aws_secret_access_key,
      aws_env_name: props.aws_env_name,
      reader_id: props.reader_id,
      garage_id: props.garage_id,
      authorization_id: props.authorization_id,
      reader_name: props.reader_name,
      dashboard_session_id: props.dashboard_session_id,
      auto_refresh: false
    };
    this.handleReaderClick = this.handleReaderClick.bind(this);
    this.fetchAuthorization = this.fetchAuthorization.bind(this);
    this.refresh = this.refresh.bind(this);
  }

  handleReaderClick(event) {
      const index = event.target.href.split("#")[1];
      console.log("handleReaderClick with index "+index)
      var garage_id = this.state.garage_id
      const reader_id = this.state.readers[index].id;
      console.log("handleReaderClick with reader_id "+reader_id)
      console.log("Fetch called from handleReaderClick")
      this.fetchAuthorization(reader_id, garage_id);
  }

  showAuthorizationDetails(auth) {
    console.log("showAuthorizationDetails called with auth "+JSON.stringify(auth))
    this.setState({authorization: auth, isLoading: false, errorMessage: null, reader_id: auth.reader_id, reader_name: auth.reader_name});
  }

  padTime(s) {
    var s = Math.floor(s);
    if (s >= 10) {
      return ""+s;
    }
    return "0"+s;
  }

  formatTime(str) {
    if (str == null) {
      return "";
    }
    var date;
    var match = str.match(/^(\d{1,2})\/(\d{1,2}) (\d{2}):(\d{2}):(\d{2}) (\w+)$/);
    if (match) {
      var year = new Date().getFullYear();
      date = new Date(match[1]+"/"+match[2]+"/"+year+" "+match[3]+":"+match[4]+":"+match[5]+" "+match[6]);
    } else {
      date = new Date(str);
    }
    if (isNaN(date.getTime())) {
      return str;
    }
    var day = date.getDate();
    var month = date.getMonth()+1;
    var timeZone = new Intl.DateTimeFormat("en-US", { timeZoneName: "short" }).formatToParts(date).find(function(part) { return part.type === "timeZoneName"; });
    var timeZoneAbbrev = timeZone ? timeZone.value : "";
    return ""+month+"/"+day+" "+this.padTime(date.getHours())+":"+this.padTime(date.getMinutes())+":"+this.padTime(date.getSeconds())+" "+timeZoneAbbrev;
  }

  render () {
    console.log("start render")
    var header = "";
    if (this.state.errorMessage) {
      header = this.state.errorMessage;
    }

    var readersHeader = (<p>No gates available</p>)
    if (this.state.readers != null) {
      var readerElements = []
      for (var i = 0; i < this.state.readers.length; i++) {
        const reader = this.state.readers[i]
        readerElements.push ( <span key={i}><a href={'#'+i} onClick={this.handleReaderClick}>{reader.name}</a> {i < this.state.readers.length-1 ? "|": ""} </span> )
      }
      readersHeader = (<p>{readerElements}</p>)

    }
    if (this.state.authorization != null) {
      var reasoning = null;
      if (this.state.authorization.reasoning) {
        reasoning = JSON.parse(this.state.authorization.reasoning)
      }
      var authorized = <h2 className="authorized">Authorized</h2>
      if (this.state.authorization.authorized_credential == null) {
        authorized = <h2 className="not-authorized">Not Authorized</h2> 
      }
      if (this.state.authorization.authorized_permit_identifier != null) {
        if (reasoning && reasoning.reason && reasoning.reason.indexOf("hourly fallback") > 0){
          authorized = <h2 className="authorized">Authorized by hourly fallback</h2> 
        }
        else {
          authorized = <h2 className="authorized">Authorized by permit {this.state.authorization.authorized_permit_identifier}</h2> 
        }
      }
      
      var permitHeader = ( <h3>No Permits</h3> ) 
      var reason = "NO CREDENTIAL"
      if (reasoning) {
        reason = reasoning.reason;
        if (reasoning.permit_reasons.length > 0) {
          permitHeader = ( <h3>Evaluated Permits:</h3> ) 
        }
        var permitRows = [];
        for (var i = 0; i < reasoning.permit_reasons.length; i++) {
          var className = reasoning.permit_reasons[i].reason == "permit_active_and_unused" ? "authorized" : "not-authorized"
          permitRows.push ( <p key={i} className={className}>{reasoning.permit_reasons[i].permit_identifier}: {reasoning.permit_reasons[i].reason}</p> )
        }
        var hourlyInfo = null;
        var hourlyHeader = ( <p>No hourly information applicable</p> );
        if (reasoning.hourly_info) {
          hourlyHeader = ( <h3>Hourly Info:</h3> )
          hourlyInfo = (
            <div>
            <p className={reasoning.hourly_info.hourly_allowed ? "authorized" : "not-authorized"}>Hourly Enabled for Garage: {reasoning.hourly_info.hourly_allowed ? "YES" : "NO"}</p>
            <p className={reasoning.hourly_info.sufficient_funds ? "authorized" : "not-authorized"}>Sufficient Funds: {reasoning.hourly_info.sufficient_funds ? "YES" : "NO"}</p>
            <p className={reasoning.hourly_info.handsfree_autopay ? "authorized" : "not-authorized"}>Handsfree Autopay Enabled: {reasoning.hourly_info.handsfree_autopay ? "YES" : "NO"}</p>
            <p className={reasoning.hourly_info.is_garage_close ? "not-authorized" : "authorized"}>Garage Closed: {reasoning.hourly_info.is_garage_close ? "YES" : "NO"}</p>
            </div>
          )
        }  
        var correlationHeader = ( <h3>Correlation Info:</h3> )
        var correlationRows = [];
        correlationRows.push(<p key={0}>Correlated entry: {reasoning.correlated_entry ? this.formatTime(reasoning.correlated_entry) : "None"}</p>)        
        correlationRows.push(<p key={1}>Correlated By: {reasoning.correlated_by}</p>) 
        if (reasoning.rejected_correlation_reasons != null && reasoning.rejected_correlation_reasons.length > 0) {
          correlationRows.push(<p key={2}>Rejected correlation candidates and reasons:</p>)        
          for (var i = 0; i < reasoning.rejected_correlation_reasons.length; i++) {
            if (reasoning.rejected_correlation_reasons[i].reason.indexOf("Failed correlation techniques") == 0) {
              correlationRows.push ( <p key={i+3}>{reasoning.rejected_correlation_reasons[i].reason}</p> )
            }
            else {
              correlationRows.push ( <p key={i+3}>* {this.formatTime(reasoning.rejected_correlation_reasons[i].detected_at)}: {reasoning.rejected_correlation_reasons[i].reason}</p> )
            }
          }
        }

        var confirmationInfo = null;
        var confirmationHeader = ( <p>Pre-Authorization</p> );
        var previous_auth = null;
        if (reasoning && reasoning.previous_authorization_id) {
          previous_auth = (
            <p>Pre-Gate Authorization did not match!  See auth id: {reasoning.previous_authorization_id}</p>
          );
        }

        if (this.state.authorization.gate_opened_at) {
           confirmationHeader = ( <p>Transit Confirmation</p> );
           confirmationInfo = (
            <div>
              <p>The system opened the gate due to a successful authorization.</p>
              {previous_auth}
            </div>
          );

        }
        else if (this.state.authorization.passed_gate_at) {
           confirmationHeader = ( <p>Transit Confirmation</p> );
           confirmationInfo = (
            <div>
              <p>The gate was not opened by the lane controller, but the driver passed the gate somehow anyway.</p>
              {previous_auth}
            </div>
          );

        }
      }
      var formattedCredential = this.state.authorization.credential ? formatRawCredentialString(this.state.authorization.credential, this.state.authorization.credential_type) : "NONE";
      console.log("returning from render")
      return (
        <React.Fragment>
        <div id="authorization" className={this.state.isLoading ? "loading" : "done-loading"}>
        {header}
        {readersHeader}
        <h1>{this.state.reader_name} <button style={{fontSize: "15px"}}  onClick={this.refresh}>Refresh Lane Auths</button></h1>
        <p><input type="checkbox" checked={this.state.auto_refresh} onChange={this.toggleAutoRefresh} /> Auto Refresh</p>
        <h3 style={{fontWeight: "bold"}}>Recent authorization attempt:</h3>

        <p>Loop 1 detected at: {this.formatTime(this.state.authorization.detected_at)}</p>
        <p>Gate opened at: {this.formatTime(this.state.authorization.gate_opened_at)}</p>
        <p>Passed Gate at: {this.formatTime(this.state.authorization.passed_gate_at)}</p>
        <p/>
        <h3 style={{fontWeight: "bold"}}>Identified Member:</h3>
        <p>Credential: {formattedCredential}</p>
        <p>Member ID: {this.state.authorization.member_id ?  this.state.authorization.member_id  : "-"}</p>
        <p>Name: {this.state.authorization.name ?  this.state.authorization.name  : "UNKNOWN"}</p>
        <p/>
        <h3 style={{fontWeight: "bold"}}>Vehicle Info:</h3>
        <p>Vehicle: {this.state.authorization.vehicle ? this.state.authorization.vehicle : "UNKNOWN"}</p>
        <p>LPR: {this.state.authorization.lpr_plate || "NONE"}</p>

        <hr/>
        <p style={{fontWeight: "bold"}}>Authorization Results:</p>

        {authorized}
        {reason}
        {permitHeader}
        {permitRows}
        {hourlyHeader}
        {hourlyInfo}
        {correlationHeader}
        {correlationRows}
        {confirmationHeader}
        {confirmationInfo}
        <hr/>
        <h3 style={{fontWeight: "bold"}}>All {this.state.authorizations.length} authorizations for lane:</h3>
        <table style={{width: "100%"}}>
        <thead>
          <tr>
            <th>Detected At</th>
            <th>Credential</th>
            <th>Name</th>
            <th>Vehicle</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
        {this.state.authorizations.map((auth, index) => {
          return (
            <tr key={index}>
              <td>{this.formatTime(auth.detected_at)}</td>
              <td>{auth.credential ? formatRawCredentialString(auth.credential, auth.credential_type) : "NONE"}</td>
              <td>{auth.name}</td>
              <td>{auth.vehicle ? auth.vehicle : "UNKNOWN"}</td>
              <td><a onClick={() => this.showAuthorizationDetails(auth)}>Show</a></td>
            </tr>
          )
        })}
        </tbody>
        </table>
        </div>
        </React.Fragment>
      );
    }
    else {
    return (
        <React.Fragment>
        <div id="authorization" className={this.state.isLoading ? "loading" : "done-loading"}>
        {header}
        {readersHeader}
        <h1>{this.state.reader_name}</h1>
        <p>No recent authorization attempt</p>
        </div>
        </React.Fragment>
      );
    }
  }

  toggleAutoRefresh = () => {
    this.setState({auto_refresh: !this.state.auto_refresh})
  }

  componentDidMount() {
    console.log("component mount start")
    var garage_id = this.state.garage_id
    const reader_id = this.state.reader_id
    if (garage_id == null) {
      garage_id =  window.location.pathname.split("/")[2]
      console.log("no garage set -- setting based on window value "+window.location.pathname.split("/")[2].split("#")[0])
    }
    console.log("Fetch called from componentDidMount")
    this.fetchAuthorization(reader_id, garage_id, this.state.authorization_id);
    this.watchForNextAuthorization(garage_id);  
    console.log("component mount end")
  }

  refresh() {
    this.fetchAuthorization(null, null)
  }
  fetchAuthorization(in_reader_id, in_garage_id, requested_authorization_id) {
    console.log("in_reader_id "+in_reader_id)
    console.log("this.state.reader_id "+this.state.reader_id)
    const reader_id = in_reader_id || this.state.reader_id
    const garage_id = in_garage_id || this.state.garage_id
    console.log("fetching authorization for "+reader_id)
    var that = this;
    var url = window.location.protocol+"//"+window.location.host+"/api/v2/authorization/"+reader_id+'?garage_id='+garage_id
    var responseAfterPromise = null;
    console.log('start fetch '+url);
    that.setState({isLoading: true, errorMessage: null});
    console.log('start fetch2 '+url);
    fetch(url)
      .then(res => {responseAfterPromise = res; return res.json();})
	    .then(json => {
          console.log('end fetch: '+json);
          var authorization = json;
          if (responseAfterPromise.status === 200) {
            if (requested_authorization_id != null) {
              for (var i = 0; i < json.authorizations.length; i++) {
                if (json.authorizations[i].id == requested_authorization_id) {
                  authorization = json.authorizations[i];
                  break;
                }
              }
            }
            that.setState({authorization: authorization, readers: json.readers, authorizations: json.authorizations || [], isLoading: false, errorMessage: null, reader_id: reader_id, reader_name: json.reader_name});

            console.log('end fetch state change');
            return Promise.resolve(json);
          }
          var errorMessage = responseAfterPromise.statusText;
          if (json.errors && typeof json.errors === 'object' && json.errors.constructor === Array && json.errors.length > 0) {
            errorMessage = json.errors.join("; ");
          }
          return Promise.reject(new Error(errorMessage));
	    })
	    .catch(function(error) {
  	      var errorString = ""+error;
          that.setState({isLoading: false, errorMessage: ''+error});
        });
  }

  watchForNextAuthorization(garage_id) {
    console.log("watchForNextAuthorization called")
    var consumer = ActionCable.createConsumer();
    var channel = "TransitsChannel"; 
    console.log("Creating action cable named "+channel);
    const that = this;
    const id = garage_id;
    consumer.subscriptions.create({channel:channel, id: garage_id}, {
      initialized: function() {
        console.log("TransitsChannel initialized for garage "+id);
        // Called when the subscription is ready for use on the server
      },

      connected: function() {
        console.log("TransitsChannel connected for garage "+id);
        // Called when the subscription is ready for use on the server
      },
    
      reconnected: function() {
        console.log("TransitsChannel reconnected for garage "+id);
      },

      disconnected: function() {
        console.log("TransitsChannel disconnected for garage "+id);
        // Called when the subscription has been terminated by the server
      },
    
      received: function(message) {
        console.log("TransitsChannel received message: "+message);
        console.log("message changed from "+that._last_websocket_message+" to "+message);
        that._last_websocket_message = message;
        if (that.state.auto_refresh) {
        that.fetchAuthorization();
          that.fetchAuthorization();
        }
      }
    });
  }
}

Authorization.propTypes = {
  greeting: PropTypes.string
};
export default Authorization
